import { render, staticRenderFns } from "./dynamic-form.vue?vue&type=template&id=58714694&scoped=true"
import script from "./dynamic-form.vue?vue&type=script&lang=js"
export * from "./dynamic-form.vue?vue&type=script&lang=js"
import style0 from "./dynamic-form.vue?vue&type=style&index=0&id=58714694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58714694",
  null
  
)

export default component.exports